/* istanbul ignore file */

import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { hideScrollbar, mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const productLabel = css`
  position: absolute;
  left: 0;
  top: 15px;
`;

export const imagesWrapper = css`
  margin: 0 -${spacing.md}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0;
    `,
  )}
`;

export const mainImageWrapperWithThumbnails = css`
  position: relative;
  display: flex;
  overflow-x: auto;
  scroll-behavior: auto;
  scroll-snap-type: x mandatory;

  ${hideScrollbar}

  &[data-image-focus='true'] {
    box-shadow: 0 0 0 3px var(--neutral-white-base), 0 0 0 5px var(--brand-purple-base);
  }

  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.M },
    css`
      margin: 0 0 ${spacing.md}px;
      border-radius: 10px;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      border-radius: 20px;
    `,
  )}
`;

export const carouselSlide = css`
  scroll-snap-align: center;
  scroll-snap-stop: always;
  min-width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--neutral-black-10);
`;

export const carouselContainer = css`
  position: relative;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 2 / -1;
    `,
  )}
`;

const mainImageBorderRadius = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      border-radius: 10px;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      border-radius: 20px;
    `,
  )}
`;

export const mainImageLink = css`
  display: block;
  flex-basis: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &.focus-visible:focus {
    outline: none !important;
    box-shadow: none;
  }

  ${mainImageBorderRadius}
`;

export const mainImage = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const imageThumbnails = css`
  display: none;
  margin-top: ${spacing.md}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: block;
    `,
  )}
`;

export const favouriteButtonWrapper = css`
  position: absolute;
  right: ${spacing.md}px;
  bottom: ${spacing.md}px;
`;

export const favouriteButton = css`
  position: absolute;
  right: 0;
  bottom: 0;
`;
